const invalidEmail = 'E-Mail ist ungültig.';
const intro = 'Präsentation';

const de: LocaleType = {
  cancellation: {
    noRefund: 'Non refundable',
    free: 'Free cancellation',
    arrival: (...args: string[]) =>
      `${args[0]} ${parseInt(args[0]) > 1 ? 'days' : 'day'} before arrival`,
  },
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Stornieren',
  update: 'Aktualisieren',
  login_button: 'Anmelden',
  signout: 'Abmelden',
  menu: 'Menu',
  loading: 'Bitte warten...',
  read_more: 'Lesen Sie mehr',
  camps: {
    allImagesButton: (...args: string[]) => `All Images (${args[0]})`,
  },
  auth: {
    successAuth: 'Erfolgreich authentifiziert. Umleitung zur Homepage',
    processing: 'Verarbeitung der Authentifizierung',
    invalidAuth: 'Ungültige Sitzung für den Benutzer.',
  },
  errors: {
    default: 'Diese Anforderung konnte nicht übermittelt werden',
    duplicate: 'Daten befinden sich bereits im System.',
    invalidEmail: invalidEmail,
    requiredEmail: 'E-Mail-Adresse ist erforderlich.',
    invalidName: 'Name ist ungültig.',
    requiredName: 'Name ist erforderlich.',
    invalidDate: 'Datum ist ungültig.',
    requiredDate: 'Datum ist erforderlich.',
    disclaimer:
      'Sie müssen den Haftungsausschluss akzeptieren, um fortzufahren.',
  },
  cookie: {
    message:
      'Diese Website verwendet Cookies, um Ihnen eine großartige Benutzererfahrung zu bieten. Durch die weitere Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies in Übereinstimmung mit uns.',
    policy: 'Cookie-Richtlinie',
    accept: 'Akzeptieren',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hallo ${args[0]}, `,
        bookings: 'überprüfen Sie hier Ihre eigenen Buchungen',
        check_bookings: 'Überprüfen Sie Ihre Buchungen',
        has_reservation: 'Haben Sie bereits eine Reservierung? ',
        customer_service: 'Customer Service',
      },
      menus: {
        home: 'Startseite',
        parks: 'Parks',
        our_story: intro,
        for_host: 'Für die Wirte',
        the_cities: 'Für die Städte',
        contact_us: 'Kontaktieren Sie uns',
        login: 'Anmelden',
        language: (...args: string[]) => `${args[0]}`,
      },
      buy_tickets: 'Tickets kaufen',
      buy: 'Kaufen',
      all_parks: 'Alle Parken',
      make_reservation: 'Jetzt buchen',
      for_host: 'Für die Wirte',
      demonstration: 'Präsentation',
      the_cities: 'Für die Städte',
      the_press: 'Für die Presse',
    },
    footer: {
      follow: 'Folgen Sie uns',
      contact: 'Kontakte',
      quick_links: 'Schnelllinks',
      traveling: 'Reisen mit Ihr',
      other_links: 'Andere links',
      privacy_statement: 'Datenschutzerklärung',
      terms_of_delivery: 'Lieferungsbedingungen',
      see_map: 'Siehe Standorte in der Karte',
      travel: 'Gemeinsam mit Ihnen unterwegs',
      privacy: 'Datenschutzerklärung',
      media: 'Für die Presse',
      phone: 'Customer service',
    },
    hero: {
      title: 'Der beste Weg zu bleiben!',
      text: 'Wir eröffnen die ersten sechs Parks für die Sommersaison 2020.',
      view_parks: 'Sehen Sie sich die Parks an',
    },
  },
  parks_list_page: {
    hero: {
      title: 'Lempäälä',
      text:
        'Ein moderner Caravan-Park mit tollen Annehmlichkeiten direkt neben Tampere.',
    },
  },
  park_info: {
    header: 'Wählen Sie Ihr Ankunftsdatum aus dem Kalender',
    amenities: (...args: string[]) =>
      `${args[0]} Plätze und ${args[1]} Annehmlichkeiten`,
    faq: 'Häufig gestellte Fragen',
    extras: {
      area: 'Region',
      forWhom: 'Für wen',
      thingsToDo: 'Sehenswertes und Aktivitäten',
    },
    intro: intro,
    country: 'Land',
    region: 'Region',
    location: 'Lage',
    night: 'Nacht',
    show_more: 'Zeig mehr',
    show_less: 'Zeige weniger',
    suitable_for: 'Passend für',
    caravan: 'Wohnwagen',
    camper_van: 'Camper Van',
    tent: 'Zelt',
    cottages: 'Hütten',
    startsFrom: 'Slot price per nacht',
  },
  reservation: {
    noReservation: 'Keine Reservierungen',
    continue: 'Weiter',
    previous: 'Vorherigen',
    loading: 'Bitte warten...',
    slots: {
      header: 'Wie viele Nächte übernachten Sie?',
      choose: 'Select Slot',
      chooseTitle: 'Einen Platz buchen',
      arrival: (...args: string[]) => `Ihr Ankunftsdatum ${args[0]}.`,
      comment: (...args: string[]) =>
        `Da das nächste Wochenende ausverkauft ist, können die maximalen Übernachtungen pro Aufenthalt ${args[0]} sein.`,
      price: (...args: string[]) => `(${args[0]}€/nacht)`,
      addPrice: (...args: string[]) => `(+${args[0]}€/nacht)`,
      summary: (...args: string[]) =>
        `The total cost for this reservation is ${args[0]}€.`,
    },
    coupon: {
      validateCoupon: 'Überprüfen',
      couponCode: 'Coupon Code',
      couponApplied: 'Coupon Applied.',
      couponDiscount: 'Coupon Beschreibung',
      validationFailed: 'Validierung fehlgeschlagen.',
      validation: {
        couponCodeInvalid: 'Ungültiger Gutscheincode.',
        couponExpired: 'Der Gutschein ist abgelaufen.',
        invalidCamp: 'Gutschein nicht für ausgewählten Campingplatz gültig.',
        usageLimitExceeded: 'Grenze für Gutscheinverwendung überschritten.',
        customerNightsLimitExceeded:
          'Grenze für Gutscheinnächte überschritten.',
        customerRemainingNights: (...args: string[]) =>
          `Mit dem Gutschein sind noch ${args[0]} Nächte verfügbar.`,
      },
    },
    registration: {
      booking: 'Buchung',
      of: 'von',
      header: 'Geben Sie Ihre Kontaktinformationen ein',
      subheader: 'Bestehendes Best Park-Konto?',
      login: 'Melden Sie sich hier an',
      loginNote: 'Melden Sie sich hier an',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      phoneInfo: '(im internationalen Format, z. B. +358401234567)',
      phoneLabel: 'Bitte geben sie ihre Telefonnummer ein',
      email: 'Email',
      street: 'Adress',
      postalCode: 'Postleitzahl',
      town: 'Stadt',
      country: 'Land',
      license: 'Registrationsnummer',
      membershipCard1: 'SF Caravan',
      membershipCard2: 'C.C.I.',
      membershipNote:
        'Sie müssen diese Karte beim Einchecken in dieses Camp vorlegen und sie muss während Ihres gesamten Aufenthalts gültig sein.',
      promos:
        'Ich möchte die neuesten Nachrichten und Angebote von Best Park per E-Mail erhalten.',
      marketing:
        'Melden Sie sich für unseren Newsletter an und erhalten Sie die neuesten Angebote und Gutscheine',
      newsletter:
        'Wir versenden ungefähr einmal im Monat einen Newsletter mit relevanten Angeboten für Sie.',
      next: 'Nächster',
      errors: {
        fillRequired: 'Bitte füllen Sie hervorgehobene Felder aus.',
        email: invalidEmail,
        name: 'Name is required.',
        licensePlate: 'License plate number is required.',
        phone:
          'Die Nummer muss im internationalen Format sein, zum Beispiel +358401234567.',
        membership:
          'Die Mitgliedsnummer muss das Format 123456-1 oder 1234567-1 haben',
        emailExist: 'E-Mail ist bereits registriert.',
        fieldRequired: 'Pflichtfeld',
        fieldTooLong: 'Der Feldwert ist zu lang',
      },
      clickHereToReserve: 'Klicken Sie hier, um Ihre Reservierung zu starten',
    },
    parking: {
      header: 'Parking',
      subheader: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      noSlots: 'No parking slots available',
    },
    payment: {
      header: 'Ihre Buchungszusammenfassung',
      subheader:
        'Bitte wählen Sie Ihre Zahlungsmethode aus, um Ihre Reservierung abzuschließen.',
      night: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nächte' : 'Nacht'} im Park`,
      total: 'Gesamt',
      cardPay: 'Bezahlen mit Kredit- und Debitkarten',
      mobilePay: 'Bezahlen mit mobilen Zahlungen',
      collectorBankPay: 'Pay with installments',
      stripePay: 'Bezahlen mit Stripe',
      invoicePayment: 'Pay with invoice',
      invoiceNote: (...args: string[]) =>
        `billing surcharge ${args[0]} ${
          Number(args[0]) > 1 ? 'euros' : 'euro'
        }`,
      surcharge: 'Surcharge',
      onlineBankPay: 'Pay with online bank',
      coupon: 'Haben Sie einen Gutscheincode?',
      continueWithoutCoupon: 'Weiter ohne Gutscheincode.',
      terms1: 'Ich habe die',
      terms2: 'Geschäftsbedingungen gelesen und verstanden.',
      terms3:
        'Wir erstellen auch ein Konto für Sie für die einfachere Nutzung Ihrer Best Park Käufe.',
      pay: (...args: string[]) => `Jetzt ${args[0]} bezahlen`,
      processingPayment: 'Bearbeitung der Reservierungszahlung',
      paymentProcessed: 'Die Zahlung wurde verarbeitet.',
      paymentError:
        'Something went wrong! Our team will look into this. You may contact support.',
      paymentCancelled: 'Zahlung storniert, bitte versuchen Sie es erneut.',
      priceDetails: 'Preisangaben',
      additionalGuests: 'Zusätzliche gäste',
      discount: 'Any discount codes can be entered in the next screen.',
      goToPayment: 'Zur Zahlung gehen',
      to: 'zu',
    },
    card: {
      goToReservation: 'Zur Reservierung',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nächte' : 'Nacht'}`,
    },
    profile: {
      header: 'Ihre Reservierung',
    },
    guestInformation: {
      passenger: 'Passagier',
      passengers: 'Passagiere',
      header: 'Meldeformular für reisende',
      firstName: 'Vorname',
      lastName: 'Nachname',
      address: 'Adresse',
      dateOfBirth: 'Geburtsdag',
      nationality: 'Staatsangehörigkeit',
      passportNumber: 'Pass',
      dateOfArrival: 'Einreisedatum',
      countryOfEntry: 'Land, aus dem Einreise nach Finnland',
      addChildButton: 'Familienmitglied hinzufügen',
      addPassenger: 'Passagier hinzufügen',
      passengerInformation: 'Persönliche Daten des Passagiers',
      childSpouseInfo: 'Persönliche Daten des Familienmitglieds',
      passportInfo:
        'Bürger aus den nordischen Ländern oder Reisende mit Wohnsitz in Finnland füllen nicht ',
      companionHeader:
        'Persönliche Daten des Ehepartners und der minderjährigen Kinder in Begleitung des Reisenden',
      subHeader:
        'Die Angabe falscher Personalien ist im Strafgesetz mit Strafe bedroht',
      delete: 'Löschen',
      campPassengerHeader: 'Bitte geben Sie Fahrgastdaten an',
      campPassengerSubHeader:
        'Wir sind gesetzlich verpflichtet, diese Informationen anzufordern, und die Angabe falscher personenbezogener Daten wird strafrechtlich verfolgt',
      next: 'Next',
      completeData:
        'Für jeden Passagier werden vollständige persönliche Daten benötigt.',
    },
    ancillary: {
      header: 'Zusätzliche Dienstleistungen',
      skip: 'Überspringen Sie diese',
      subheader1: 'Bleiben Sie unterwegs, während Sie geparkt sind!',
      subheader2: 'Wir haben Elektroroller und Fahrräder in allen Parks',
      subheader3:
        'Begrenzte Mänge pro Park so reservieren Sie Ihre im Voraus noch heute!',
      soldOut: 'Leider ausverkauft für alle Tage Ihres Aufenthaltes.',
      soldOutDay: (...args: string[]) =>
        `Alle ${args[0]} sind für diesen Tag reserviert`,
      price: (...args: string[]) => `${args[0]}€ pro Tag`,
      reservation: (...args: string[]) =>
        `Für wie viele ${args[0]} und für welche Tage brauchen Sie sie?`,
      max: (...args: string[]) => `Nur ${args[0]} für diesen Tag verfügbar`,
      total: 'Gesamt:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Tage' : 'Tag'
        }`,
      firstDayNote:
        'Die Reservierung beginnt um 13:00 Uhr und endet am nächsten Tag um 12:00 Uhr',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Einloggen',
      checkOut: 'Austragen',
      startBooking: 'Buchung starten',
      perNight: 'per Nacht',
      info:
        'Die Check-in-Zeit beginnt jeden Tag um 13:00 Uhr und der Check-out ist bis 12.00 Uhr',
      addOns: {
        earlyCheckIn: {
          info: 'Früher Check-in ab 13 Uhr',
          button: (...args: string[]) => `Hinzufügen für ${args[0]}€`,
        },
        lateCheckOut: {
          info: ' Später Ausschecken um 15:00 Uhr',
          button: (...args: string[]) => `Hinzufügen für ${args[0]}€`,
        },
      },
      parking: {
        title: 'Your Slot',
        slot: (...args: string[]) =>
          `When you arrive to the park your reserved slot is number ${args[0]}.`,
      },
      map: {
        button: 'Navigieren zum Park',
      },
      general: {
        title: 'Der Port öffnet sich',
        text:
          'Bei der Ankunft im Park, können Sie das Tor mit diesem persönlichen Code öffnen:',
        linkInfo: (...args: string[]) =>
          `Informationen anzeigen auf ${args[0]}`,
        linkModify: 'Möchten Sie diese Reservierung ändern oder stornieren?',
        linkDownload: 'Laden Sie Ihre Quittung herunter',
        add: 'Hinzufügen',
      },
      services: {
        title: (...args: string[]) => `Deine ${args[0]}`,
        text: (...args: string[]) =>
          `Es wird hier Anweisungen haben, wo Sie die ${args[0]} abholen können, die Sie reserviert haben.`,
      },
      cancelReservation: 'Reservierung stornieren',
      cancelledReservation: 'Reservierung storniert',
    },
    confirmation: {
      confirmed: 'Reservierung bestätigt.',
      pending: 'Die Reservierung ist derzeit ausstehend.',
      confirmed_message: (...args: string[]) =>
        `Vielen Dank für Ihre Reservierung, wir freuen uns auf Ihren Besuch in ${args[0]}.`,
    },
    errors: {
      cancel: 'Sie können Ihre Buchung 7 Tage vor Anreise stornieren',
    },
    success: {
      cancel: 'Reservierung erfolgreich storniert.',
    },
    receipt: {
      invoice: (...args: string[]) => `Receipt #${args[0]}`,
      header: (...args: string[]) =>
        `Thank you for your payment for reservation ${args[0]}, it has been paid in full for the amount of ${args[1]}€`,
      details: {
        paymentDate: 'Payment date',
        contactEmail: 'Contact email',
        chargedTo: 'Charged to',
        forReservation: 'For reservation',
      },
      breakdown: {
        subtotal: 'Subtotal',
        grandTotal: 'Grand total',
        vat: (...args: string[]) => `VAT (${args[0] ?? 10}%)`,
      },
    },
    widget: {
      additionalGuests: 'Zusätzliche gäste',
      from: 'Ab',
      priceBreakdown: 'Price breakdown',
      night: 'Nacht',
      nights: (...args: string[]) =>
        `für ${args[0]} ${parseInt(args[0]) > 1 ? 'Nächte' : 'Nacht'}`,
      total: 'Gesamt',
      inclusions: 'Dieser Übernachtungspreis beinhaltet:',
    },
    sendBookingRequest: {
      submit: 'Sende Reservierungsanfrage',
      success: 'Reservierungsanfrage erfolgreich gesendet.',
      error: 'Reservierungsanfrage konnte nicht gesendet werden.',
      disclaimer:
        'Ich verstehe, dass dies keine verbindliche Reservierung für beide Parteien ist. Nach dem Absenden dieser Reservierungsanfrage wird sich der Campingplatz mit Ihnen in Verbindung setzen, um die Verfügbarkeit eines möglichen Stellplatzes für Ihr Fahrzeug zu bestätigen.',
    },
  },
  promotions: {
    general: {
      read_more: 'Lesen Sie mehr',
    },
    hotline: {
      title: 'Hilfe-Service 24/7',
      text: 'Unser Kundenservice ist immer verfügbar',
      footer: 'The price of a call is 8,35 cent/call + 16,69 cent/minute',
    },
    infos: {
      title: 'Beeinflussen!',
      text:
        'Tippen Sie auf die besten Plätze und nehmen Sie an der Verlosung der Geschenkkarte teil.',
      buttonText: 'Zur Befragung',
    },
  },
  login: {
    header: 'Melden Sie sich bei Ihrem Konto an',
    subheader: 'Noch kein Konto? ',
    registrationLink: 'Registrieren Sie sich hier',
    forgetPasswordLink: 'Passwort vergessen?',
    email: 'E-Mail',
    password: 'Passwort',
    continue: 'Weiter',
    authContent: 'Enter authentication code sent to ',
    editNumber: 'Nummer bearbeiten',
    verify: 'Verifizierungs-Schlüssel',
    sms: 'per SMS gesendet',
    errors: {
      fillRequired: 'Bitte füllen Sie hervorgehobene Felder aus.',
      email: 'E-Mail ist ungültig.',
      sessionInvalidated: 'Sitzung abgelaufen bitte melden Sie sich erneut an',
      invalidCode: 'Ungültiger Code',
    },
    verifyRequired: 'Verification code is required',
    resendCode: 'Code erneut senden',
    resending: 'erneut senden...',
    next: 'Next',
  },
  mail: {
    header: 'Check your phone',
    open: 'Mail-App öffnen',
    content: (...args: string[]) =>
      `Wir haben einen Login-Link an die ${args[0]} gesendet, um Sie anmelden zu können.`,
  },
  registration: {
    header: 'Registrieren eines Kontos',
    subheader: 'Bestehendes Best Park-Konto? ',
    registerButton: 'Registrieren',
    success: {
      header: 'Sie haben sich erfolgreich registriert.',
      content: 'Sie können sich jetzt bei Ihrem Konto anmelden.',
    },
  },
  profileEdit: {
    header: 'Profilkonto bearbeiten',
    subheader: 'Aktualisieren Ihrer Kontodetails',
    editButton: 'Profil bearbeiten',
    success: {
      header: 'Sie haben Ihr Konto erfolgreich aktualisiert.',
      content: 'Kundenkonto',
    },
  },
  calendar: {
    general: {
      start_reservation: 'Reservierung starten',
      select_check_in: 'Bitte wählen Sie das Eincheckdatum aus.',
      select_check_out:
        'Wählen Sie das Checkout-Datum aus und klicken Sie auf Buchung starten.',
      summary: (...args: string[]) =>
        `Reservation from ${args[0]} to ${args[1]}.\nCheck in at 13:00, check out at 12:00. Total price: ${args[2]}€.`,
    },
    months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'Dezember',
    },
    in_months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'Dezember',
    },
    weeks: {
      monday: 'Mo',
      tuesday: 'Di',
      wednesday: 'Mi',
      thursday: 'Do',
      friday: 'Fr',
      saturday: 'Sa',
      sunday: 'So',
    },
  },
  parks: {
    from: 'Ab',
    check_advance: 'Check in advance',
    promotion: (...args: string[]) =>
      `Wir haben ${args[0]} moderne Parks für den Sommer ${args[1]}`,
    per_night: 'pro Tag',
    listTitle: (...args: string[]) => `Sommer ${args[0]} parks:`,
  },
  newsletter: {
    title: 'Aktuelles-Brief bestellen',
    subscribe: 'Bestellen',
    subscribeMsg:
      'Abonnieren Sie unseren Aktuelles-Brief und hören Sie als Erster die BestPark-Neuichkeiten',
    notifications: {
      subscribeSuccess: 'Vielen Dank für Ihre Kontaktaufnahme!',
      subscribeError:
        'Ihre Anfrage konnte nicht verarbeitet werden. Bitte, erneut versuchen.',
    },
  },
  mediaPage: {
    visualisation: 'Visuelle Bilder',
    stock: 'Illustrationen',
    parkImages: 'Presentation of the premises',
  },
  contactUs: {
    billingHeader: 'Abrechnungsinformationen',
    businessId: 'Umsatzsteuer-Identifikationsnummer',
    paymentTerm: 'Zahlungsbedingungen',
    paymentTermValue: (term: string) => `${term} days`,
    invoiceAddress: 'E-Rechnungsadresse',
    brokerAddress: 'Vermittlersadresse',
    send: 'Abschicken',
  },
  formLabels: {
    message: 'Ihre Nachricht',
    name: 'Name',
    email: 'E-Mail',
    phoneNumber: 'Telefon',
    place: 'Ort',
    authCode: 'Authentifizierungscode',
  },
  amenities: {
    title: 'Ausstattung',
  },
  other: {
    title: 'Other Info',
    cancellationPolicy: 'Stornierungsbedingungen',
    notes: 'Info',
  },
};

export default de;
